// extracted by mini-css-extract-plugin
module.exports = {"changeLink":"TenantRow_changeLink__21Pts","tenantRow":"TenantRow_tenantRow__2knty"};